export enum DashboardType {
  CA = 'cloud_agent',
  EP = 'endpoint',
  WAS = 'web_app',
  SAST = 'sast',
  SAST2 = 'sast2',
  PC = 'pc', // Policy Compliance
  KPI = 'kpi', // Key Performance Indicator
  BPA = 'bpa', // Best Practice Assessment
}

export enum Severity {
  All = 'All',
  Urgent = 'Urgent',
  Critical = 'Critical',
  Serious = 'Serious',
  Medium = 'Medium',
  Minimal = 'Minimal',
}

export enum VulnerabilityStatus {
  Active = 'ACTIVE',
  New = 'NEW',
  Reopened = 'REOPENED',
  Fixed = 'FIXED',
  Ignored = 'IGNORED',
}

export enum TimespanFilter {
  OneMonth = '4w',
  ThreeMonth = '3m',
  SixMonth = '6m',
  OneYear = '1y',
  // Custom = "custom"
}

export enum TimeBandView {
  ZeroToThree = '0 to 3 Days',
  ThreeToSeven = '3+ to 7 Days',
  SevenToFourteen = '7+ to 14 Days',
  FourteenToTwentyEight = '14+ to 28 Days',
  TwentyEightPlus = '28+ Days',
}

export enum MetricsType {
  Open = 'Open',
  Closed = 'Closed',
}

export enum MetricsView {
  Severity = 'Severity',
  Time = 'Time',
}

export enum ChartType {
  Bar = 'Bar',
  Doughnut = 'Doughnut',
  BarStacked = 'BarStacked',
}

export enum IntervalFilter {
  Week = '1w',
  FourWeeks = '4w',
  ThreeMonth = '3m',
  SixMonth = '6m',
}

export enum IntervalFilterType {
  SkipRecords,
  AggregateCounts,
}

export enum VulnStatus {
  All = 'All',
  Fixed = 'Fixed',
  New = 'New',
  Ignored = 'Ignored',
  Reopened = 'Reopened',
}

export interface GroupingDataItem {
  qid: string;
  name: string;
  count: number;
}

export interface ModalDialogData {
  title: string;
  subTitle?: JSX.Element;
  bodyComponent: JSX.Element;
}

export type TooltipLabelsType = Array<{
  label: string;
  hostsCount: number | null;
}>;
